// react
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';

// components
import { ChromeTemplate } from '@karehero/llama/pwa/templates/ChromeTemplate/ChromeTemplate';
import { type LinkItem } from '@karehero/llama/pwa/molecules/NavDrawer/NavDrawer';
import { type AccountInfoProps } from '@karehero/llama/pwa/atoms/AccountInfo/AccountInfo';

// store
import { useSelector } from 'store';
import { getAccount, getKindeAccount } from 'store/slices/iamSlice';

// hooks
import { useAuth } from 'hooks';
import useIntercom from 'hooks/useIntercom';

// utils
import { getProfilePictureUrl } from '@karehero/llama/pwa/utils/getProfilePictureUrl';

export const RootVerify = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();
  const account = useSelector(getAccount);
  const kindeAccount = useSelector(getKindeAccount);
  const { signOut } = useAuth();
  const { showIntercom } = useIntercom();

  const userName = useMemo(() => {
    return `${account?.firstName || ''} ${account?.lastName || ''}`;
  }, [account]);

  const userFallback = useMemo(() => {
    return `${account?.firstName?.[0] || ''}${account?.lastName?.[0] || ''}`;
  }, [account]);

  const navLinks: LinkItem[] = useMemo(
    () => [
      {
        icon: 'key-skeleton',
        label: 'Verification',
        to: ROUTES.VERIFY_ACCESS,
        onClick: () => navigate(ROUTES.VERIFY_ACCESS),
      },
      {
        icon: 'message',
        label: 'Support',
        onClick: showIntercom,
      },
    ],
    [showIntercom, navigate],
  );

  const navDrawerAccountInfoProps: AccountInfoProps = useMemo(
    () => ({
      role: '',
      name: userName,
      fallback: userFallback,
      avatarSrc: getProfilePictureUrl(account),
      onSignOut: signOut,
      isMenuDisabled: true,
      order: 'avatar-first' as const,
    }),
    [userName, userFallback, kindeAccount, signOut],
  );

  return (
    <ChromeTemplate
      links={navLinks}
      accountInfoProps={navDrawerAccountInfoProps}
      activePath={location.pathname}
    />
  );
};

RootVerify.displayName = 'RootVerify';
export default RootVerify;
